import { hideNominatePeersSidePanelAction, showNominatePeersSidePanelAction } from 'actions/nominatePeers';
import history from 'meshHistory';

import { NOMINATION_PANEL_CLOSING_STATUS } from 'constants/ProjectConstants';
import { getNominatePeersRoute, getRouteAfterRemovingNominatePeers, noOp } from 'constants/helper';

export const showNominatePeers =
  ({ reviewId, empId, emp, headerText = null, onSubmit = noOp, nominationEndDateTS }) =>
  (dispatch) => {
    history.push(getNominatePeersRoute({ location: history.location, reviewId, empId }));
    return dispatch(
      showNominatePeersSidePanelAction({
        reviewId,
        empId,
        emp,
        headerText,
        onSubmit,
        nominationEndDateTS,
      })
    );
  };

export const hideNominatePeers =
  (closingStatus = NOMINATION_PANEL_CLOSING_STATUS.SUCCESSFUL) =>
  (dispatch) => {
    const route = getRouteAfterRemovingNominatePeers({ location: history.location });
    history.push(route);
    return dispatch(hideNominatePeersSidePanelAction({ closingStatus }));
  };
